import { render } from "./EditDevoirPage.vue?vue&type=template&id=c3f36a9a&ts=true"
import script from "./EditDevoirPage.vue?vue&type=script&lang=ts"
export * from "./EditDevoirPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__